<template>
  <svg viewBox="0 0 48 48">
    <path
      d="m35 14h-10v-5.163c1.442-.432 2.5-1.754 2.5-3.337 0-1.933-1.567-3.5-3.5-3.5s-3.5 1.567-3.5 3.5c0 1.583 1.058 2.905 2.5 3.337v5.163h-10c-3.314 0-6 2.686-6 6v19c0 3.314 2.686 6 6 6h22c3.314 0 6-2.686 6-6v-19c0-3.314-2.686-6-6-6zm-21 11.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5zm16.457 10.949c-1.975 1.015-4.208 1.551-6.457 1.551s-4.482-.536-6.457-1.551c-.491-.253-.685-.855-.433-1.347.252-.49.854-.685 1.347-.433 3.435 1.766 7.651 1.766 11.086 0 .491-.252 1.094-.058 1.347.433.252.491.059 1.094-.433 1.347zm.043-7.449c-1.933 0-3.5-1.567-3.5-3.5s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5-1.567 3.5-3.5 3.5z" />
    <circle cx="30.5" cy="25.5" r="1.5" />
    <circle cx="17.5" cy="25.5" r="1.5" />
    <path d="m44 23h-1v13h1c1.657 0 3-1.343 3-3v-7c0-1.657-1.343-3-3-3z" />
    <path d="m5 23h-1c-1.657 0-3 1.343-3 3v7c0 1.657 1.343 3 3 3h1z" />
  </svg>
</template>
